module.exports = __webpack_public_path__ + "img/57.ea16a700.jpg";